import './index.scss';
import {
    IconPlusSmallWhite, IconPencilFillCircle
} from '../../icons/svgs';

import SidebarMenuItem from './MenuItem';
import React, { useEffect, useState } from "react";
import he from 'he';


import {
    DndContext,
    closestCenter,
    KeyboardSensor,
    PointerSensor,
    useSensor,
    useSensors,
} from '@dnd-kit/core';
import {
    arrayMove,
    SortableContext,
    sortableKeyboardCoordinates,
    verticalListSortingStrategy,
} from '@dnd-kit/sortable';

import { restrictToVerticalAxis } from '@dnd-kit/modifiers';

function Sidebar({ slides, setSelectedSlide, setSelectedSlideIndex, setActionUpdateTemplate, selectedSlideIndex, lessonTitle, setSlides, selectedSlide, setOpenModalSaveTitleLesson }) {
    const [saveDisabled, setSaveDisabled] = useState('');

    const showModalNewSlide = () => {
        setActionUpdateTemplate(false)
        window.jQuery('#tbcourse-modal-new-slide').modal('show');
    }
    const handleClick = (index) => {
        const slide = slides[index];
        setSelectedSlide(slide);
        setSelectedSlideIndex(index);
    }

    const handleShowModalEditTitle = () => {
        setOpenModalSaveTitleLesson(true)
        window.jQuery('#tbcourse-modal-edit-lesson-title').modal('show');
    }

    const sensors = useSensors(
        useSensor(PointerSensor),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates,
        })
    );

    const handleDragEnd = (event) => {
        const { active, over } = event;

        if (!active) {
            return;
        }
        if (!over) {
            return;
        }

        if (active.id !== over.id) {

            const firstIndex = 0;
            const lastIndex = (slides.length) - 1;
            const toOverIndex = over.data.current.sortable.index;
            const firstSlideCanRearrange = slides[firstIndex].template?.canRearrange();
            const lastSlideCanRearrange = slides[lastIndex].template?.canRearrange();

            // disable move to first and last
            // if (toOverIndex === firstIndex || toOverIndex === lastIndex) {
            //     return;
            // }

            // disable move to first by slide on first
            if (!firstSlideCanRearrange && toOverIndex === firstIndex) {
                return;
            }
            // disable move to last by slide on last
            if (!lastSlideCanRearrange && toOverIndex === lastIndex) {
                return;
            }

            setSlides((items) => {
                const oldIndex = items.indexOf(items.find((item) => item.id === active.id));
                const newIndex = items.indexOf(items.find((item) => item.id === over.id));

                // if old index is selected, so move selected to new index
                if (oldIndex === selectedSlideIndex) {
                    // setSelectedSlide(items[newIndex]);
                    // setSelectedSlideIndex(newIndex);
                    handleClick(newIndex);
                }

                return arrayMove(items, oldIndex, newIndex);
            });
        }
    }

    useEffect(() => {
        if (selectedSlide) {
            setSaveDisabled(selectedSlide.saveDisabled)
        }
    });

    return (
        <div className="tbcourse-sidebar">
            <div className="tbcourse-header tbcourse-sidebar-header">
                <div className="tbcourse-header-title">
                    Content
                </div>
                <div className="tbcourse-header-action">
                    <button type="button" className='btn btn-add-slide font-weight-500' onClick={showModalNewSlide} disabled={saveDisabled}>
                        {/* New Slide <ReactSVG src={IconPlusSmallWhite} wrapper='span'/> */}
                        New Slide <IconPlusSmallWhite />
                    </button>
                </div>
            </div>
            <div className="tbcourse-body tbcourse-sidebar-body">
                <div className="accordion" id="lesson-item">
                    <div className="card tbcourse-sidebar-lesson-item">
                        <div className="card-header">
                            <h2 className="mb-0 tbcourse-sidebar-lesson-item-header d-grid">
                                <button
                                    type="button"
                                    className="btn btn-link btn-block text-left p-0 d-flex justify-content-between"
                                    onClick={handleShowModalEditTitle}
                                >
                                    <span className='btn-label text-uppercase' title={he.decode(lessonTitle)}>
                                        {/* {manager.settings?.lessonTitle ?? 'Untitled'} */}
                                        {he.decode(lessonTitle)}
                                    </span>
                                    <IconPencilFillCircle />
                                </button>
                            </h2>
                            {/* <h2 className="mb-0 d-flex">
                                <button className="btn btn-link btn-block text-left p-0 d-flex justify-content-between" type="button" data-toggle="collapse" data-target="#lesson-one" aria-expanded="true" aria-controls="lesson-one">
                                    <span className='text-uppercase'>Lesson Title</span>
                                    <ReactSVG src={IconChevronDownCircle} wrapper='span'/>
                                </button>
                            </h2> */}
                        </div>

                        {/* <div id="lesson-one" className="collapse show" data-parent="#lesson-item"> */}
                        <div className={`card-body ${saveDisabled ? 'disabled' : ''}`}>
                            <div className="tbcourse-item tbcourse-sidebar-item">

                                {/* {slides.map((item, index) => (
                                        <SidebarMenuItem selectedSlideIndex={selectedSlideIndex} index={index} slide={item} handleClick={handleClick} key={index} />
                                    ))} */}

                                <DndContext
                                    sensors={sensors}
                                    collisionDetection={closestCenter}
                                    onDragEnd={handleDragEnd}
                                    modifiers={[restrictToVerticalAxis]}
                                >
                                    <SortableContext
                                        items={slides}
                                        strategy={verticalListSortingStrategy}
                                    >
                                        {/* {slides.map(id => <SortableItem key={id} id={id} />)} */}
                                        {slides.map((item, index) => (
                                            <SidebarMenuItem selectedSlideIndex={selectedSlideIndex} index={index} slide={item} handleClick={handleClick} id={item.id} key={index} handle={true} />
                                        ))}
                                    </SortableContext>
                                </DndContext>

                            </div>
                        </div>
                        {/* </div> */}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Sidebar;
